import { Window } from "../../../ui/Window.js";
import { ServiceLayer } from "../ServiceLayer.js";

export { ActiveFilters }

/**
 * @memberof vef.map.layer.utils
 */
class ActiveFilters extends Window {

    constructor(target) {
        super(target, {
            height: "unset",
            width: "470px",
            open: false,
            draggable: true,
            responsive: true
        })

        this.container_ = document.createElement("div");
        this.container_.classList.add("active-filters");
        this.setContent(this.container_);
    }

    clear() {
        this.container_.innerHTML = "";
    }

    add(key, dimension, values) {
        const element = document.createElement("div");
        element.classList.add("dimension");
        if (dimension.disabled) element.classList.add("disabled");

        element.innerHTML = `
            <span class="fa-stack">
                <i class="far fa-square fa-stack-1x"></i>
                <i class="fas fa-check fa-stack-1x"></i>
            </span>
            <span class="name">${key}</span>
            <span class="values"></span>
        `;

        const valContainer = element.querySelector(".values");
        values.forEach(value => {
            valContainer.innerHTML += "<div>" + value.join(", ") + "</div>"
        });

        element.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            if (dimension.disabled) {
                element.classList.remove("disabled");
                delete dimension.disabled;
            } else {
                element.classList.add("disabled");
                dimension.disabled = true;
            }
            this.layer_.setFilter(this.layer_.filter);
            this.layer_.applyFilter();
            this.redrawDimensions();
        });

        this.container_.appendChild(element);
    }

    redrawDimensions(filter) {
        if (this.layer_) {
            this.clear();
            this.layer_.createFilterParams_(filter || this.layer_.filter);
            for (let key in this.layer_.dimensionValues) {
                this.add(key, this.layer_.dimensions[key], this.layer_.dimensionValues[key]);
            }
            for (let key in this.layer_.dimensions) {
                if (!(key in this.layer_.dimensionValues)) {
                    this.add(key, this.layer_.dimensions[key], []);
                }
            }
            for (let key in this.layer_.attributeValues) {
                this.add(key, this.layer_.attributeFields[key], this.layer_.attributeValues[key]);
            }
            for (let key in this.layer_.attributeFields) {
                if (!(key in this.layer_.attributeValues) && !(key in this.layer_.dimensions)) {
                    this.add(key, this.layer_.attributeFields[key], []);
                }
            }
        }
    }

    open(layer) {
        // set active layer
        if (layer instanceof ServiceLayer) {
            this.layer_ = layer;
            this.redrawDimensions();
        } else {
            this.layer_ = null;
            this.clear();
            this.close();
            return;
        }

        this.setTitle("FILTERS: " + layer.title);
        super.open();
    }

}